
import { useState } from 'react';

import UseModal from 'hooks/use-modal';
import useWindowSize from 'hooks/use-windowSize';

import { useMutation } from 'react-query';
import { useForm } from 'react-hook-form';
import { jobBoardJobApply } from 'services/recruitments';
import { isUserLoggedIn } from 'utils/authentication';

import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import IconButton from '@mui/material/IconButton';

import { MOBILE_FULLSCREEN, MOBILE_SLIDE_UP } from '@core/constants/ModalTypes';
import { getErrorText } from 'utils/geterrortext';
import dayjs from 'dayjs';
import CoverLetterList from 'components/pages/jobboard/jobboardjobs/jobBoardDetail/jobBoardDetailApplyButton/coverletterlist/CoverLetterList';
import ActionButton from '@core/components/actionbutton/ActionButton';
import LoginPrompt from 'components/common/loginprompt/LoginPrompt';
import Modal from '@core/components/Modal/Modal';
import LinkButton from '@core/components/linkbutton/LinkButton';
import UserFullName from 'components/common/userfullname/UserFullName';
import Loading from '@core/components/loading/Loading';
import Checkbox from '@core/components/checkbox/Checkbox';
import CartCountrySelect from 'components/pages/cart/CartCountrySelect';
import LanguageSelectorWrapper from 'components/common/languageselector/languageSelectorWrapper';

import CloseIcon from 'assets/icons/close-icon.svg';
import { TickSquare, Profile, DocumentUpload, ArrowDown2, Notepad2, ArrowLeft } from 'iconsax-react';

import classes from './JobBoardDetailApplyButton.module.scss';


const jobBoardDetailApplyButton = ({ activeJob, company, toast }) => {
	const { mobileDevice } = useWindowSize();
	const [selectedCoverLetter, setSelectedCoverLetter] = useState('')
	const [resumeFile, setResumeFile] = useState(null);
	const [pharmuniProfile, setPharmuniProfile] = useState(false);
	const [coverLetterFile, setcoverLetterFile] = useState(null);
	const [expanded, setExpanded] = useState(true);
	const [selectedCountry, setSelectedCountry] = useState(null);
	const [step, setStep] = useState(1);
	const accordionStyle = {
		'&': {
			boxShadow: 'none',
		},
		'& div': {
			padding: 0,
		},
		'&>div>div': {
			margin: 0,
		},
		'&>div>div>div': {
			width: '100%',
		}
	}
	const { mutate, data, isLoading, refetch } = useMutation(
		['job-board-job', activeJob],
		() => jobBoardJobApply.GET(activeJob),
		{
			onSuccess: (data) => {
				showModal();
				setSelectedCountry(data.data.user.about_me.residential_country_iso);
			},
			onError: (error) => {
				if (error.response.status === 401) {
					loginNoticeShowModal();
				}
				else if (error.response.status === 422) {
					showFullnameModal();
				}
				else if (error.response.status === 400)
					toast(getErrorText(error), 'alert');
			}
		}
	);
	const { mutate: applyJobPost, isLoading: isUploadLoading } = useMutation(jobBoardJobApply.POST,
		{
			onSuccess: () => {
				destroyModal();
				showApplySuccessfulModalModal();
			},
			onError: (error) => {
				if (error.response.status === 401) {

				}
				toast(getErrorText(error), 'alert');
			}
		}
	);

	const {
		register,
		handleSubmit,
		setValue,
		formState: { errors, isDirty, isValid },		
	} = useForm({
		mode: 'onChange',
		defaultValues:
			(data && {
				...data
			}) ||
			{}
	});

	const { destroyModal, show, showModal } = UseModal();
	const {
		show: loginNoticeVisible,
		showModal: loginNoticeShowModal,
		destroyModal: loginNoticeDestroyModal
	} = UseModal();
	const {
		show: showFullname,
		destroyModal: destroyFullnameModal,
		showModal: showFullnameModal
	} = UseModal();
	const {
		show: showApplySuccessful,
		destroyModal: destroyApplySuccessfulModal,
		showModal: showApplySuccessfulModalModal
	} = UseModal();

	const handleHowToApply = () => {
		if (isUserLoggedIn()) {
			mutate();
		} else {
			loginNoticeShowModal();
		}
	};

	const uploadResume = (e) => {
		const fileSize = e?.target?.files[0]?.size / 1024 / 1024;
		if (e?.target?.files[0] && fileSize > 10) {
			toast(
				'File size is too large! please make sure the selected file is smaller than 10 Mb.',
				'alert'
			);
		} else {
			setResumeFile(e?.target?.files[0]);
		}
	};
	const uploadCoverLetter = (e) => {
		const fileSize = e?.target?.files[0]?.size / 1024 / 1024;
		if (e?.target?.files[0] && fileSize > 10) {
			toast(
				'File size is too large! please make sure the selected file is smaller than 10 Mb.',
				'alert'
			);
		} else {
			setcoverLetterFile(e?.target?.files[0]);
			setSelectedCoverLetter('');
		}
	};

	const submitForm = (payload) => {
		if ((!selectedCountry || data?.data?.user?.about_me?.languages.length === 0) && step === 1) {
			setStep(2);
			return;
		}
		if (!resumeFile && !pharmuniProfile) {
			toast(
				'Please upload your resume or select pharmuni profile',
				'alert'
			);
			return;
		}
		if (!selectedCountry || payload.languages.length === 0) {
			toast(
				'Please select your residential location and at least one language',
				'alert'
			);
			return;
		}
		const formData = new FormData();
		formData.append('residential_country_iso', selectedCountry.iso2);
		formData.append('languages', JSON.stringify(payload.languages));
		formData.append('visa_sponsorship', payload.visa_sponsorship);
		formData.append('use_public_profile', pharmuniProfile);		
		if (selectedCoverLetter != '' && !coverLetterFile)
			formData.append('cover_letter_id', selectedCoverLetter);
		if (resumeFile)
			formData.append('resume', resumeFile);
		if (coverLetterFile)
			formData.append('cover_letter', coverLetterFile);

		applyJobPost({ activeJob, payload: formData });
	};
	const removeResume = (e) => {
		e.preventDefault();
		setResumeFile(null);
	};
	const removeCoverLetter = (e) => {
		e.preventDefault();
		setcoverLetterFile(null);
	};
	const languageChangeHandler = (newlanguages) => {
		setValue('languages', newlanguages);
	};


	return (
		<>
			<ActionButton kind="primary" loading={isLoading} onClick={handleHowToApply}>
				Apply
			</ActionButton>
			<Modal type={MOBILE_FULLSCREEN} header={false} closeHandler={destroyModal} show={show}>
				<div className={`${classes['apply-modal-wrapper']} d-flex flex-column gap-4`}>
					<div className='d-flex flex-row-reverse justify-content-between '>
						<IconButton onClick={destroyModal}>
							<CloseIcon />
						</IconButton>
						{step === 2 &&
							<IconButton onClick={() => setStep(1)}>
								<ArrowLeft />
							</IconButton>
						}
					</div>
					<div className={`${classes['apply-modal-company']} d-flex flex-column gap-3  `}>
						<p>You are applying to</p>
						<div className={classes["company-info"]}>
							{company.data.company.logo ? (
								<img src={company.data.company.logo} alt={company.data.company.name} />
							) : (
								<span>{company.data.company.name[0]}</span>
							)}
							<h4>
								{company.data.company.name}
							</h4>
						</div>
						<div className={classes["job-title"]}>
							{data?.data?.job_post.title}
						</div>
					</div>

					<form onSubmit={handleSubmit(submitForm)}>
						<div className={step === 1 ? 'd-flex flex-column gap-4' : 'd-none'}>
							<div className={`${classes['upload-file-section']} d-flex-row `}>
								<Accordion expanded={expanded} onChange={() => setExpanded(true)} sx={accordionStyle}>
									<AccordionSummary
										aria-controls="panel1-content"
										id="panel1-header"
									>
										<div className='d-flex justify-content-between align-items-center'>
											<h3>Your Resume *</h3>
											<div className={classes['link']}>
												{expanded ? (
													data?.data?.user.has_resume && (
														<LinkButton kind='simple' href={'/profile/my-resume'}>Create your Resume</LinkButton>
													)
												) : (
													<>
														{pharmuniProfile && (<Profile size={31} color='#18BBA8' />)}
														{resumeFile && (<DocumentUpload size={31} color='#18BBA8' />)}
													</>
												)}

											</div>
										</div>
									</AccordionSummary>
									<AccordionDetails>
										{data && !isLoading && (
											<>
												{data.data.user.has_resume ? (
													<div
														role='button'
														onClick={() => setPharmuniProfile(!pharmuniProfile)}
														className={pharmuniProfile ? `${classes['pharmuni-profile-wrapper']} ${classes['active']}` : classes['pharmuni-profile-wrapper']}
													>
														<div className='d-flex align-items-center gap-3'>
															<TickSquare size={24} color='#18BBA8' />
															<div>
																<h3>Your Pharmuni profile</h3>
																<span>Updated {data?.data?.user?.latest_resume_update}</span>
															</div>
														</div>
														<Profile size={31} color='#18BBA8' />
													</div>
												) : (
													<div className={classes['no-profile']}>
														<span>Pharmuni Profile</span>
														<LinkButton to={'/profile/my-resume'}>Create your pharmuni profile</LinkButton>
													</div>
												)}
											</>
										)}


										<div className={resumeFile ? `${classes["file-input-wrapper"]} ${classes['has-file']}` : classes["file-input-wrapper"]}>
											<div className={`${classes['file-input']} d-flex-row row`}>
												<input
													type="file"
													id="resume"
													name='resume'
													onChange={uploadResume}
													accept="application/msword, text/plain, application/pdf"
													max="1048576"
													className=""
												/>
												<label htmlFor="resume" className={resumeFile ? '' : classes['no-resume-file']}>
													<div className='d-flex align-items-center gap-3 '>
														<TickSquare size={24} color='#18BBA8' />
														<div>
															{resumeFile ? (
																<h5>{resumeFile.name}</h5>
															) : (
																<>
																	<span> Attach a resume file</span>
																	<p>PDF, DOC, TXT smaller than 10MB</p>
																</>
															)}
														</div>
													</div>
													{resumeFile ? (
														<div className={classes["remove-btn-container"]}>
															<ActionButton kind='blank-warnign' className="p-0" onClick={(e) => removeResume(e)}>
																Remove
															</ActionButton>
														</div>
													) : (
														<DocumentUpload size={31} color='#4ECDC4' />
													)}
												</label>
											</div>
										</div>
									</AccordionDetails>
								</Accordion>
							</div>
							<div className={`${classes['upload-file-section']} d-flex-row row`}>
								<Accordion expanded={!expanded} onChange={() => setExpanded(false)} sx={accordionStyle}>
									<AccordionSummary
										aria-controls="panel2-content"
										id="panel2-header"
									>
										<div className={`${classes['link']} d-flex justify-content-between align-items-center`}>
											<h3>+ Add your Cover Letter</h3>
											<LinkButton kind='simple' href={'/profile/my-resume'}>Create your Resume</LinkButton>
										</div>

									</AccordionSummary>
									<AccordionDetails>
										<div className={`${classes['pharmuni-cover-letter']} d-flex-row `}>
											<Accordion sx={accordionStyle}>
												<AccordionSummary
													expandIcon={<ArrowDown2 size={17} />}
													aria-controls="panel3-content"
													id="panel3-header"
												>
													<div className="d-flex align-items-center gap-3">
														<Notepad2 size={29} color='#666664' />
														Pharmuni cover letter
													</div>
												</AccordionSummary>
												<AccordionDetails>
													<CoverLetterList setSelectedCoverLetter={setSelectedCoverLetter} />
												</AccordionDetails>
											</Accordion>

										</div>
										<div className={coverLetterFile ? `${classes["file-input-wrapper"]} ${classes['has-file']}` : classes["file-input-wrapper"]}>
											<div className={`${classes['file-input']} d-flex-row row`}>
												<input
													type="file"
													id="cover_letter"
													name='cover_letter'
													onChange={uploadCoverLetter}
													accept="application/msword, text/plain, application/pdf"
													max="1048576"
													className=""
												/>
												<label htmlFor="cover_letter" className={coverLetterFile ? classes['coverletter-file'] : classes['no-coverletter-file']}>
													<DocumentUpload size={29} />
													{coverLetterFile ? (
														<>

															<div className='d-flex justify-content-between w-100 py-2'>
																<span>{coverLetterFile.name}</span>
																<ActionButton kind='blank-warnign' onClick={(e) => removeCoverLetter(e)} className="p-0">
																	Remove
																</ActionButton>
															</div>

														</>
													) : (
														<div>
															<span> Attach a cover letter file</span>
															<p>PDF, DOC, TXT smaller than 10MB</p>
														</div>
													)}
												</label>
											</div>

										</div>
									</AccordionDetails>
								</Accordion>
							</div>
							<div className={`${classes['visa-wrapper']} ${data?.data?.job_post?.visa_sponsorship ? 'd-flex justify-content-center' : 'd-none'} `}>
								<Checkbox
									input={{
										name: `visa_sponsorship`,
										label: `I want to use ${data?.data?.job_post?.company?.name} Visa sponsership and relocation offer`,
										id: `visa_sponsorship`,
									}}
									register={register}
								/>
							</div>
						</div>
						{data && (
							<div className={step === 2 ? 'd-block' : 'd-none'}>
								<CartCountrySelect
									input={{
										type: 'text',
										label: 'Residential Location',
										name: 'residential_country_iso',
										placeholder: 'Where do you currently live?',
										id: 'residential_country_iso',
										autoComplete: 'off'
									}}
									errors={errors}
									register={register}
									selectedCountry={selectedCountry}
									setSelectedCountry={setSelectedCountry}
									mobileDevice={mobileDevice}
									setValue={setValue}
									horizontal={false}
								/>
								<LanguageSelectorWrapper
									data={data?.data?.user?.about_me?.languages}
									metadata={data?.data?.user?.about_me?.metadata}
									languageChangeHandler={languageChangeHandler}
									horizontal={false}
								/>
							</div>
						)}


						<ActionButton disabled={!resumeFile && !pharmuniProfile} type="seubmit" className="mt-3">
							{isUploadLoading ? (<Loading color='white' />
							) : (
								<>
									{((selectedCountry && data?.data?.user?.about_me?.languages.length > 0) || step === 2) ? 'Apply' : 'Next'}
								</>
							)}
						</ActionButton>
					</form >

				</div >
			</Modal >
			<Modal
				type={MOBILE_FULLSCREEN}
				closeHandler={loginNoticeDestroyModal}
				show={loginNoticeVisible}>
				<div
					className={`${classes['login-notice-modal']} d-flex flex-column justify-content-center container`}>
					<div className={`d-flex flex-column align-items-center justify-content-center`}>
						<LoginPrompt />
					</div>
				</div>
			</Modal>
			<Modal type={MOBILE_SLIDE_UP} show={showFullname} closeHandler={destroyFullnameModal}>
				<div className={`${classes['user-fullname-wrapper-modal']} d-flex flex-column gap-2`}>
					<UserFullName
						title=""
						description="We need your name to continue. Enter your name below. Please note that your name is not editable later"
						callback={() => {
							mutate();
							destroyFullnameModal();
						}}
					/>
				</div>
			</Modal>
			<Modal type={MOBILE_SLIDE_UP} show={showApplySuccessful} closeHandler={destroyApplySuccessfulModal}>
				<div className={`${classes['apply-modal-wrapper']} d-flex flex-column gap-4`}>
					<div className={`${classes['apply-modal-company']} d-flex flex-column gap-3  `}>
						{/* <p>You are applying to</p> */}
						<div className={classes["company-info"]}>
							{company.data.company.logo ? (
								<img src={company.data.company.logo} alt={company.data.company.name} />
							) : (
								<span>{company.data.company.name[0]}</span>
							)}
							<h4>
								{company.data.company.name}
							</h4>
						</div>
						<div className={classes["job-title"]}>
							{data?.data?.job_post?.title}
						</div>
					</div>
					<h2>You have successfully applied!</h2>
					<ActionButton onClick={destroyApplySuccessfulModal}>Explore more jobs</ActionButton>
				</div>
			</Modal>
		</>
	);
};

export default jobBoardDetailApplyButton;
